import React, { useState } from "react";
import "./Foodclientlanding.css";
import FoodPaidClents from "./FoodPaidClents";
import Foodsubscribedclients from "./Foodsubscribedclients";
import Foodenquery from "./Foodenquery";


const TabsLayout = () => {
  const [activeTab, setActiveTab] = useState("Registration");

  const DummySection = ({ title }) => (
    <div className="dummy-box">
      <h2>{title}</h2>
      <p>This is a dummy section for <strong>{title}</strong>.</p>
      <span>Content will be added later 🚧</span>
    </div>
  );

  const renderComponent = () => {
    switch (activeTab) {
      case "Enquiry":
        return <Foodenquery />;
      case "Registration":
        return <FoodPaidClents />;
      case "Subscribed":
        return <Foodsubscribedclients title="Subscribed" />;

      default:
        return <Foodenquery />;
    }
  };

  const tabs = [
    // "Enquiry",
    "Registration",
    "Subscribed",

  ];

  return (
    <div className="tabs-wrapper">
      {/* TOP ONE-ROW TABS (ALL SCREENS) */}
      <div className="tabs-row">
        {tabs.map((tab) => (
          <span
            key={tab}
            className={`row-tab ${activeTab === tab ? "active" : ""}`}
            onClick={() => setActiveTab(tab)}
          >
            {tab}
          </span>
        ))}
      </div>

      {/* CONTENT */}
      <div className="tabs-content">
        {renderComponent()}
      </div>
    </div>
  );
};

export default TabsLayout;

